import api from "../api";

export const signIn = async (payload) => {
  const response = await api.post("/PMSRoutes/SignIn", payload);
  return response.data;
};
